import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { IDrawDto } from '@models/draw/dtos/draw-dto';
import { DrawFilterForm } from '@models/draw/filters/draw-filter';
import { DrawPostForm } from '@models/draw/forms/draw-post-form';
import { ResponseDto } from '@models/exceptions/response-dto';
import { IPage } from '@models/pagination/page';
import { PageRequest } from '@models/pagination/page-request';
import { catchError, map, Observable } from 'rxjs';
import { MessageErrorResolver } from '../../utilities/message-error-resolver';
import { LoadingService } from './loading.service';
import { IDrawSimpleDto } from '@models/draw/dtos/draw-simple-dto';

@Injectable({
  providedIn: 'root',
})
export class DrawService {
  private url: string = environment.apiUrl + '/v1/sorteios';

  constructor(
    private httpClient: HttpClient,
    private messageErrorResolver: MessageErrorResolver,
    private loadingService: LoadingService
  ) {}

  public findDraws$(
    filters: DrawFilterForm,
    pageRequest: PageRequest
  ): Observable<IPage<IDrawSimpleDto>> {
    let params = new HttpParams();
    if (pageRequest.size) params = params.set('size', pageRequest.size);
    if (pageRequest.page) params = params.set('page', pageRequest.page);
    if (filters.catNrId) params = params.set('catNrId', filters.catNrId);
    if (filters.sorTxNome) params = params.set('sorTxNome', filters.sorTxNome);
    if (filters.catTxNome) params = params.set('catTxNome', filters.catTxNome);


    return this.httpClient
      .get<ResponseDto<IPage<IDrawSimpleDto>>>(this.url, { params })
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }

  public findDrawById$(sorNrId: number): Observable<IDrawDto> {
    let params = new HttpParams();
    return this.httpClient
      .get<ResponseDto<IDrawDto>>(`${this.url}/${sorNrId}`, { params })
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }

  public saveDraw$(form: DrawPostForm): Observable<IDrawDto> {
    return this.httpClient
      .post<ResponseDto<IDrawDto>>(`${this.url}`, form)
      .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }

  public editDraw$(sorNrId: number, form: DrawPostForm): Observable<IDrawDto> {
    return this.httpClient
    .put<ResponseDto<IDrawDto>>(`${this.url}`, form)
    .pipe(
        map((response) => response.response),
        catchError((err) => {
          this.loadingService.deactivate();
          this.messageErrorResolver.resolveMessage(err);
          throw err;
        })
      );
  }
}
